import React from 'react';

function DashboardPage() {
  const getUserData = () => {
    try {
      const userData = localStorage.getItem('userData');
      return userData ? JSON.parse(userData) : null;
    } catch (error) {
      return null;
    }
  };

  const user = getUserData();
  const firstName = user?.firstName || 'User';

  return (
    <div className="user-home-layout__page">
      <div className="user-home-layout__page-header">
        <h1 className="user-home-layout__page-title">Welcome, {firstName}!</h1>
        <p className="user-home-layout__page-subtitle">
          Get started with CerebralMachines AI Platform
        </p>
      </div>

      <div className="user-home-layout__dashboard">
        <div className="user-home-layout__card">
          <h2 className="user-home-layout__card-title">Getting Started</h2>
          <p className="user-home-layout__card-text">
            Welcome to CerebralMachines.ai! Here are some quick steps to get you started:
          </p>
          <ul className="user-home-layout__list">
            <li>Set up your first workspace</li>
            <li>Create and configure graphs for your AI models</li>
            <li>Integrate with your existing systems</li>
            <li>Invite team members to collaborate</li>
          </ul>
        </div>

        <div className="user-home-layout__card">
          <h2 className="user-home-layout__card-title">Quick Links</h2>
          <div className="user-home-layout__quick-links">
            <a href="/user-home/workspaces" className="user-home-layout__quick-link">
              <span className="user-home-layout__quick-link-icon">📁</span>
              <span className="user-home-layout__quick-link-text">Workspaces</span>
            </a>
            <a href="/user-home/graphs" className="user-home-layout__quick-link">
              <span className="user-home-layout__quick-link-icon">📊</span>
              <span className="user-home-layout__quick-link-text">Graphs</span>
            </a>
            <a href="/user-home/integrations" className="user-home-layout__quick-link">
              <span className="user-home-layout__quick-link-icon">🔗</span>
              <span className="user-home-layout__quick-link-text">Integrations</span>
            </a>
            <a href="/user-home/settings" className="user-home-layout__quick-link">
              <span className="user-home-layout__quick-link-icon">⚙️</span>
              <span className="user-home-layout__quick-link-text">Settings</span>
            </a>
          </div>
        </div>

        <div className="user-home-layout__card">
          <h2 className="user-home-layout__card-title">Recent Activity</h2>
          <p className="user-home-layout__card-text user-home-layout__card-text--muted">
            No recent activity to display.
          </p>
        </div>
      </div>
    </div>
  );
}

export default DashboardPage;



